export const PUBLIC_ROUTES = [
  '/account/login',
  '/account/forgotpassword',
  '/reset-password',
];
